import Link from 'next/link';
import { useState } from 'react';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import Button from 'src/components/buttons/button';

const onHelpClick = (e) => {
  e.preventDefault();
  window.HelpScoutBeacon.triggerHelpScoutBeacon('USER_SUPPORT');
};

const onGetHelpClick = (e) => {
  e.preventDefault();
  window.HelpScoutBeacon.triggerHelpScoutArticle('11-community-guidelines');
};

const onCookiesSettingsClick = (e) => {
  e.preventDefault();
  if (window.CookieControl) {
    window.CookieControl.open();
  }
};

export default function Sections() {
  const [isCompanyHidden, setIsCompanyHidden] = useState(true);
  const [isProductHidden, setIsProductHidden] = useState(true);
  const [isSupportHidden, setIsSupportHidden] = useState(true);

  return (
    <>
      <div>
        <SectionHeader onClick={() => setIsCompanyHidden(!isCompanyHidden)}>
          <h2>{i18n.t('Company')}</h2>
          <OpenIcon isOpen={isCompanyHidden} />
        </SectionHeader>
        <LinkList $isHidden={isCompanyHidden}>
          <li>
            <a href="https://about.healthunlocked.com" rel="noreferrer" target="_blank">
              {i18n.t('About Us')}
            </a>
          </li>
          <li>
            <a href="https://about.healthunlocked.com" rel="noreferrer" target="_blank">
              {i18n.t('Partner with us')}
            </a>
          </li>
          <li>
            <a href="https://about.healthunlocked.com/careers" rel="noreferrer" target="_blank">
              {i18n.t('Careers')}
            </a>
          </li>
        </LinkList>
      </div>
      <div>
        <SectionHeader onClick={() => setIsProductHidden(!isProductHidden)}>
          <h2>{i18n.t('Product')}</h2>
          <OpenIcon isOpen={isProductHidden} />
        </SectionHeader>
        <LinkList $isHidden={isProductHidden}>
          <li>
            <Link href="/tags">
              {i18n.t('Health terms A to Z')}
            </Link>
          </li>
          <li>
            <Link href="/communities">
              {i18n.t('Communities A to Z')}
            </Link>
          </li>
          <li>
            <a href="https://about.healthunlocked.com/start-a-community" rel="noreferrer" target="_blank">
              {i18n.t('Start a Community')}
            </a>
          </li>
        </LinkList>
      </div>
      <div>
        <SectionHeader onClick={() => setIsSupportHidden(!isSupportHidden)}>
          <h2>{i18n.t('Support')}</h2>
          <OpenIcon isOpen={isSupportHidden} />
        </SectionHeader>
        <LinkList $isHidden={isSupportHidden}>
          <li>
            <Button type="none" onClick={onHelpClick}>
              {i18n.t('Help Centre')}
            </Button>
          </li>
          <li>
            <Button type="none" onClick={onGetHelpClick}>
              {i18n.t('Community Guidelines')}
            </Button>
          </li>
          <li>
            <a href="https://about.healthunlocked.com/contact-us" rel="noreferrer" target="_blank">
              {i18n.t('Contact us')}
            </a>
          </li>
          <li>
            <Button type="none" onClick={onCookiesSettingsClick}>
              {i18n.t('Cookies settings')}
            </Button>
          </li>
        </LinkList>
      </div>
    </>
  );
}

const OpenIcon = ({ isOpen }) => <span className={`icon ${isOpen ? 'icon-down-open' : 'icon-up-open'}`} />;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .icon {
    cursor: pointer;
    color: ${({ theme }) => theme.colorWhite};
    @media (${({ theme }) => theme.overScreenSmall}) {
      display: none;
    }
  }
`;

const LinkList = styled.ul<{ $isHidden: boolean }>`
  display: ${({ $isHidden }) => $isHidden ? 'none' : 'flex'};
  flex-direction: column;
  gap: 8px;
  margin: 15px 0 0 0;
  padding: 0;
  list-style: none;
  
  @media (${({ theme }) => theme.overScreenSmall}) {
    display: flex;
  }
`;
